import { Component, inject, effect } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { BackendV4Service, SiteTemplateV4, DropDownMenu } from '../service/backend-v4.service';


import { TemplateAComponent } from './templates/template-a/template-a.component';
import { TemplateBComponent } from './templates/template-b/template-b.component';
import { TemplateCComponent } from './templates/template-c/template-c.component';

@Component({
  selector: 'app-page-builder',
  standalone: true,
  imports: [MatProgressSpinnerModule, MatTooltipModule, MatIconModule, MatCardModule, MatMenuModule, MatButtonModule, TemplateAComponent, TemplateBComponent, TemplateCComponent],
  templateUrl: './page-builder.component.html',
  styleUrl: './page-builder.component.scss',
  animations: [
    trigger('fadeOut', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('2s ease-in-out')),
    ]),
  ],
})
export class PageBuilderComponent {

  backEndV4Service = inject(BackendV4Service)
  siteTemplate: any
  params: any = null
  copyrightDate = new Date().getFullYear()
  menuVisible = true;
  activeTemplate: any = null
  template = null
  pullDownMenu: Array<DropDownMenu> = new Array()
  isNewSchool = false
  isUnderMaintenance = false

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title
  ) {

    this.siteTemplate = this.backEndV4Service.getWwwTemplate()

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.params = params
      this.renderSite()
    })

    effect(() => {
      this.renderSite()
    })
  }

  onMenuButtonClick(url: string) {
    switch (url) {
      case 'www': {
        localStorage.clear()
        const fqdn = this.backEndV4Service.getFQDN()
        window.location.href = 'https://' + fqdn + '/www/';
        break;
      };
      case 'login': {
        const fqdn = this.backEndV4Service.getFQDN()
        window.location.href = 'https://' + fqdn + '/login/';
        break;
      };
      case 'enroll': {
        const fqdn = this.backEndV4Service.getFQDN()
        window.location.href = 'https://' + fqdn + '/enroll/';
        break;
      };
      default: {
        this.router.navigate([url])
      }
    }
  }


  renderSite() {

    const keys = Object.keys(this.siteTemplate())

    if (keys.length > 0) {

      if (keys.length === 1) {
        this.isNewSchool = true
        this.router.navigate(["new/"])
      } else {
        const myVersion = "3452"

        if (this.backEndV4Service.getBackEndVersion() != myVersion) {
          if (!myVersion.startsWith("@VERSION")) {
            this.isUnderMaintenance = true
            localStorage.clear()
            return
          }
        }

        if (this.siteTemplate().info) {
          this.titleService.setTitle(this.siteTemplate().info.siteTitle)
          var faviconLink: HTMLLinkElement | null = document.querySelector("#favIcon");
          if (faviconLink) {
            faviconLink.href = this.siteTemplate().info.siteIcon
          }
        }
        if (this.siteTemplate().pages) {
          this.activeTemplate = this.siteTemplate().pages['/']
          if (this.params && this.params.keys && this.params.keys.length > 0) {
            if (this.params.get(this.params.keys[this.params.keys.length - 1])) {
              const key = this.params.get(this.params.keys[this.params.keys.length - 1])
              if (typeof key === 'string') {
                if (Object.keys(this.siteTemplate().pages).includes(key)) {
                  this.activeTemplate = this.siteTemplate().pages[key]
                  this.menuVisible = true
                  if (this.activeTemplate.isFullScreen) {
                  } else {
                  }
                } else {
                  this.router.navigate(['./'])
                }
              }
            }
          }
          this.template = this.activeTemplate.template
        }

        if (this.siteTemplate()['dropDownMenu']) {
          this.pullDownMenu = new Array()
          if (this.siteTemplate()['dropDownMenu'].length > 0) {
            for (const item of this.siteTemplate()['dropDownMenu']) {
              this.pullDownMenu.push(item)
            }
          }
        }
      }
    }
  }
}
